import { Button } from './Button.js';

interface InlineConfirmProps {
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmLabel?: string;
  confirmVariant?: 'danger' | 'warning';
  loading?: boolean;
}

/**
 * A confirm/cancel pair rendered in place of the action that asked for it (a row's "Delete" turns into "Delete?
 * [Delete] [Cancel]"). For anything that needs an explanation, use `ConfirmDialog`.
 */
export function InlineConfirm({
  message,
  onConfirm,
  onCancel,
  confirmLabel = 'Confirm',
  confirmVariant = 'danger',
  loading,
}: InlineConfirmProps) {
  return (
    <div className="flex items-center gap-2" role="group" aria-label={message}>
      <span className={confirmVariant === 'danger' ? 'text-xs text-danger' : 'text-xs text-warning'}>{message}</span>
      <Button size="sm" variant="danger" onClick={onConfirm} loading={loading}>
        {confirmLabel}
      </Button>
      <Button size="sm" variant="ghost" onClick={onCancel} disabled={loading}>
        Cancel
      </Button>
    </div>
  );
}
